<script>
  import { onMount } from 'svelte';
  import { t9n } from '../../../lib/translate.js';
  import { format_date, format_multiple_dates, format_time, is_safari, parse_date, format_float_time } from '../../../lib/utils.js';
  import { MDCDialog } from '@material/dialog';
  import moment from 'moment';
  import { TS } from '../../../config/translation-keys.js';
  import session from '../../../lib/session.js';
  import settings from '../../../config';
  // import { format } from 'date-fns';

  export let order;
  export let role;
  export let hide = false;
  export let chat = false;

  // $: console.log('order', order);
  let on_mount = false;
  let details = [];
  let map_dialog;
  let showed_location;
  let order_location;
  let currency_sign = '€';

  const init_map = () => {
    const map_el = document.getElementById('map');

    const map = new google.maps.Map(map_el, {
      zoom: 14,
      center: order_location,
    });

    const marker = new google.maps.Marker({
      position: order_location,
      map: map,
    });
  };

  const init_google_map = () => {
    window.init_map_for_order_location = init_map;

    const map_script = document.createElement('script');
    map_script.defer = true;
    map_script.src = `https://maps.googleapis.com/maps/api/js?key=${settings.google_maps_api_key}&callback=init_map_for_order_location`;
    document.body.append(map_script);
  };

  const init = () => {
    on_mount = true;
    map_dialog = new MDCDialog(document.querySelector(`#map-dialog`));
  };

  const show_map = location => {
    init_google_map();
    map_dialog.open();
    showed_location = location;
  };

  const close_map = () => {
    map_dialog.close();
    document
      .querySelectorAll('script[src^="https://maps.googleapis.com"]')
      .forEach(s => s.remove());
    document.head
      .querySelectorAll('script[src^="https://maps.googleapis.com"]')
      .forEach(s => s.remove());
  };

  const get_teams = () => {
    let teams = [];
    if (order.details.teams.public.length > 0) {
      for (let i = 0; i < order.details.teams.public.length; i++) {
        teams.push(order.details.teams.public[i].name);
      }
    }
    if (order.details.teams.private.length > 0) {
      for (let i = 0; i < order.details.teams.private.length; i++) {
        teams.push(order.details.teams.private[i].name);
      }
    }
    if (teams.length === 0) return null;
    return teams;
  };

  const get_completed = () => {
    if (
      order.status === 'order_status_delivered' ||
      order.status === 'order_status_completed' ||
      order.status === 'order_status_not_approved'
    ) {
      return order.details.confirmed_order_time;
    }
    return null;
  };

  const get_earning = () => {
    let earning = order.details.duration * order.product.worker_price;
    if (role === 'worker' && order.no_payment === false) {
      return `${earning.toFixed(2)} ${$session.merchant.currency_sign}`;
    } else {
      return null;
    }
  };

  const get_price = price => {
    if (role === 'orderer')
      return `${price.toFixed(2)} ${$session.merchant.currency_sign}`;
    return null;
  };

  const get_vat = vat => {
    if (role === 'orderer')
      return `${vat.toFixed(2)} ${$session.merchant.currency_sign}`;
    return null;
  };

  const get_total = total => {
    let total_ret = total * order.details.duration;
    if (role === 'orderer')
      return `${total.toFixed(2)} ${$session.merchant.currency_sign}`;
    return null;
  };

  const get_payment = () => {
    if (role === 'orderer') {
      if (order.hasOwnProperty('payment')) {
        if (order.payment.payment_type === 'payment_type_credit_card') {
          return (
            t9n(order.payment.payment_type) +
            ': ' +
            order.payment.credit_card_number
          );
        } else {
          return t9n(order.payment.payment_type);
        }
      }
    }
    return null;
  };

  const get_acc_ref = () => {
    if (role === 'orderer' && !!order.details.account_reference) return order.details.account_reference;
    return null;
  };

  const get_service = () => {
    let id = order.product.product_id;
    let products = $session.merchant.products;
    let language = $session.user.language;
    let localized_names;
    for (let i = 0; i < products.length; i++) {
      if (products[i].product_id === id) {
        localized_names = products[i].localized_names;
      }
    }

    if(!!localized_names){
      if (language === 'en') {
        return localized_names.translation_en;
      }
      if (language === 'ar') {
        return localized_names.translation_ar;
      }
      if (language === 'fa') {
        return localized_names.translation_fa;
      }
      if (language === 'fi') {
        return localized_names.translation_fi;
      }
      if (language === 'ru') {
        return localized_names.translation_ru;
      }
      if (language === 'sv') {
        return localized_names.translation_sv;
      }
      if (language === 'uk') {
        return localized_names.translation_uk;
      }
    }

  };

  const get_product_worker_type = () => {
    if(order.status === "order_status_initialized"){
      if(!!order.product.product_worker_type) return order.product.product_worker_type;
    } else{
      if(!!order.order_worker_type) return order.order_worker_type;
    }
    return null;
  }

  const load_details = () => {
    let loc_array = [
      order.details.address.primary_address,
      order.details.address.secondary_address,
      order.details.address.postal_code,
      order.details.address.city,
      order.details.address.region,
    ];

    if($session.merchant.multi_country){
      loc_array.push(order.details.address.country);
    }

    order_location = {
      lat: order.details.address.latitude,
      lng: order.details.address.longitude,
    };

    let location_string = '';
    for (let i = 0; i < loc_array.length; i++) {
      if (loc_array[i] !== null && loc_array[i] !== '') {
          location_string += loc_array[i] + ', ';
      }
    }

    location_string = location_string.substring(0, location_string.length - 2);

    if (role === 'worker' && order.status === 'order_status_initialized') {
      location_string = `${order.details.address.city}, ${order.details.address.postal_code}`;
    }

    let amount_string;
    if(order.product.based_on === 'product_based_hours') amount_string = `${format_float_time(order.details.duration)}`;
    if(order.product.based_on === 'product_based_days') amount_string = `${order.details.duration.toFixed(1)} ${t9n(TS.LABEL_DAYS)}`;
    if(order.product.based_on === 'product_based_months') amount_string = `${order.details.duration.toFixed(1)} ${t9n(TS.LABEL_MONTHS)}`;
    if(order.product.based_on === 'product_based_units') amount_string = `${order.details.duration.toFixed(1)} ${t9n(TS.LABEL_UNITS)}`;
    if(order.product.based_on === 'product_based_price') amount_string = `${order.details.duration.toFixed(1)} ${t9n(TS.LABEL_PRICE)}`;

    let vat = order.product.orderer_vat_amount * order.details.duration;
    let total = order.product.orderer_price * order.details.duration;
    let price = total - vat;

    // this converts UTC to local time:
    let date = format_date(order.details.created_at, true);
    let start_date = order.details.initial_start_date;
    let end_date = order.details.initial_end_date;
    let start_has_time = order.details.initial_start_has_time;
    let end_has_time = order.details.initial_end_has_time;

    let init_time;
    if(!!order.details.initial_order_time){
      init_time = order.details.initial_order_time;
    } else{
      init_time = parse_date(start_date, end_date, start_has_time, end_has_time);
    }


    let no_payment =
      order.payment && order.payment.payment_type !== 'payment_type_no_payment';
    details = [
      {
        header: t9n(TS.ORDER_TASK_DESC),
        value: order.details.description,
        type: 'string',
        show: true,
      },
      {
        header: t9n(TS.MERCHANT_LABEL_SERVICE),
        value: get_service(),
        type: 'string',
        show: true,
      },
      {
        header: t9n(TS.PRODUCT_WORKER_TYPE),
        value: t9n(get_product_worker_type()),
        type: 'string',
        show: true,
      },
      {
        header: t9n(TS.NEW_ORDER_LABEL_ADD_INFO),
        value: order.details.additional_info,
        type: 'string',
        show: true,
      },
      {
        header: t9n(TS.ORDER_TEAMS),
        value: get_teams(),
        type: 'array',
        show: true,
      },
      {
        header: t9n(TS.NEW_ORDER_HEADER_LOC),
        value: location_string,
        type: 'map',
        show: true,
      },
      {
        header: t9n(TS.TABLE_HEADER_INIT_TIME),
        value: init_time,
        type: 'string',
        show: true,
      },
      {
        header: t9n(TS.NEW_ORDER_SUM_AMOUNT),
        value: amount_string,
        type: 'string',
        show: order.product.based_on !== 'product_based_price',
      },
      {
        header: t9n(TS.NEW_ORDER_SUM_PAYMENT),
        value: get_payment(),
        type: 'string',
        show: no_payment,
      },
      {
        header: t9n(TS.ORDER_ACC_REF),
        value: get_acc_ref(),
        type: 'string',
        show: true,
      },

      {
        header: t9n(TS.ORDER_COMPLETED_TXT),
        value: get_completed(),
        type: 'string',
        show: true,
      },

      {
        header: t9n(TS.ORDER_EARNING),
        value: get_earning(),
        type: 'string',
        show: true,
      },
      {
        header: t9n(TS.TABLE_HEADER_PRICE),
        value: get_price(price),
        type: 'string',
        show: no_payment,
      },
      {
        header: t9n(TS.ORDER_VAT),
        value: get_vat(vat),
        type: 'string',
        show: no_payment,
      },
      {
        header: t9n(TS.PILOT_POINTS_HISTORY_TOTAL_LABEL),
        value: get_total(total),
        type: 'string',
        show: no_payment,
      },

      // {
      //   header: t9n(TS.ORDER_LABEL_PUBLISHED),
      //   value: date,
      //   type: 'string',
      //   show: true,
      // },
    ];

    let additional_fields = [];
    if ($session.merchant.additional_fields.length > 0) {
      $session.merchant.additional_fields.forEach(e => {
        let data = e;
        e.value = null;
        if ($session.user.language === 'ar') {
          data.label = e.translation_ar;
        }
        if ($session.user.language === 'en') {
          data.label = e.translation_en;
        }
        if ($session.user.language === 'fa') {
          data.label = e.translation_fa;
        }
        if ($session.user.language === 'fi') {
          data.label = e.translation_fi;
        }
        if ($session.user.language === 'ru') {
          data.label = e.translation_ru;
        }
        if ($session.user.language === 'sv') {
          data.label = e.translation_sv;
        }
        if ($session.user.language === 'uk') {
          data.label = e.translation_uk;
        }
        if (data.label === null) {
          data.label = e.translation_en;
        }

        additional_fields.push(data);
      });
      additional_fields.forEach(e => {
        order.details.additional_fields.forEach(f => {
          if (e.id === f.id) e.value = f.value;
        });
      });
      additional_fields.forEach(e => {
        let show = true;

        // if ($session.user.last_role === 'worker' && e.only_selected_workers && order.details.status !== "order_status_delivered") {
        //   show = false;
        // 


        let value = e.value;
        if(e.field_type === "merchant_field_type_boolean"){
          if(value){
            value = t9n(TS.TXT_YES);
          } else{
            value = t9n(TS.TXT_NO)
          }
        }

        details.push({
          header: e.label,
          value: value,
          type: 'string',
          show: show,
        });
      });
    }
  };

  $: currency_sign = $session.merchant
    ? $session.merchant.currency_sign
    : currency_sign;

  $: if (!!order && $session?.merchant?.products && on_mount) load_details();

  onMount(() => { init() });
</script>

<!-- here comes the loop -->

<div class="mdc-data-table">
  <table class="mdc-data-table__table">
    <tbody class="mdc-data-table__content">

      {#each details as item, i}
        {#if item.value !== null && item.value !== '' && typeof item.value !== undefined && item.show}
          <tr class="mdc-data-table__row">
            <!--            class:hidden={hide}-->
            <!--            {#if hide}-->
            <th
              class="mdc-data-table__cell "
              class:data-heading={hide}
              class:merge-cell={hide}>
              {item.header}
            </th>
            <!--{:else}-->
            <!--              <th class="mdc-data-table__cell"-->
            <!--              >{item.header}</th>-->
            <!--{/if}-->

            {#if item.type === 'string'}
              <td
                class="mdc-data-table__cell cell-right pre-wrap"
                class:merge-cell={hide}>
                {item.value}
              </td>
              <!--{:else}-->
              <!--  <td class="mdc-data-table__cell cell-right">{item.value}</td>-->
              <!--{/if}-->
            {/if}

            {#if item.type === 'array'}
              <td
                class="mdc-data-table__cell cell-right"
                class:merge-cell={hide}>
                {#each item.value as row, j}
                  {row}
                  <br />
                {/each}
              </td>
            {/if}
            {#if item.type === 'map'}
              <td class="mdc-data-table__cell" class:merge-cell={hide} class:chat-map-expander={chat && !order.details.address.is_virtual &&
                  ((role === 'orderer' && order.status !== 'order_status_initialized' &&
                   order.status !== 'order_status_cancelled_by_admin' && order.status !== 'order_status_cancelled_by_orderer'
                   && order.status !== 'order_status_not_approved') || (role === 'worker' && order.status !== 'order_status_initialized'
                   && order.status !== 'order_status_cancelled_by_admin' && order.status !== 'order_status_cancelled_by_orderer' &&
                   order.status !== 'order_status_not_approved'))}
                  style='display: inline-flex;'>
                <p
                  style='width: -moz-available; width: -webkit-fill-available; width: fill-available;'
                  class:location-text={!order.details.address.is_virtual && (order.status === 'order_status_in_progress' || order.status === 'order_status_delivered' || order.status === 'order_status_completed')}
                  class:chat-p-margin-fixer={chat && !order.details.address.is_virtual &&
                  ((role === 'orderer' && order.status !== 'order_status_initialized' &&
                   order.status !== 'order_status_cancelled_by_admin' && order.status !== 'order_status_cancelled_by_orderer'
                   && order.status !== 'order_status_not_approved') || (role === 'worker' && order.status !== 'order_status_initialized'
                   && order.status !== 'order_status_cancelled_by_admin' && order.status !== 'order_status_cancelled_by_orderer' &&
                   order.status !== 'order_status_not_approved'))}>
                  {#if order.details.address.is_virtual}
                    {t9n(TS.ORDERS_IS_VIRTUAL)}
                  {:else}{item.value}{/if}
                </p>

                {#if !order.details.address.is_virtual}
                  {#if (role === 'orderer' && order.status !== 'order_status_initialized' && order.status !== 'order_status_cancelled_by_admin' && order.status !== 'order_status_cancelled_by_orderer' && order.status !== 'order_status_not_approved') || (role === 'worker' && order.status !== 'order_status_initialized' && order.status !== 'order_status_cancelled_by_admin' && order.status !== 'order_status_cancelled_by_orderer' && order.status !== 'order_status_not_approved')}
                    {#if (!chat)}
                      <br/>
                    {/if}
                    <button
                      class:chat-map-height={chat}
                      on:click={() => show_map(item.value)}
                      class="mdc-button btn-showonmap mdc-button--unelevated">
                      <span class="mdc-button__ripple" />
                      <i
                        class="material-icons"
                        style="margin-right: 5px;">
                        place
                      </i>
                      {t9n(TS.ORDER_SHOW_ON_MAP)}
                    </button>
                  {/if}
                {/if}

              </td>
            {/if}
          </tr>
        {/if}
      {/each}

    </tbody>
  </table>
</div>

<div id="map-dialog" class="mdc-dialog">
  <div class="mdc-dialog__container">
    <div
      class="mdc-dialog__surface"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="my-dialog-title"
      aria-describedby="my-dialog-content">

      <!-- Title cannot contain leading whitespace due to mdc-typography-baseline-top() -->
      <h2 class="mdc-dialog__title" id="my-dialog-title">
        {t9n(TS.ORDER_TASK_LOC)}
        <p class="showed_location">{showed_location}</p>
      </h2>

      <div class="mdc-dialog__content" id="my-dialog-content">
        <div class="mapouter">
          <div id="map" style="width: 750px; height: 500px" />
          <!-- <div class="gmap_canvas">
            <iframe
              width="750"
              height="500"
              id="gmap_canvas"
              src={map_url}
              frameborder="0"
              scrolling="no"
              marginheight="0"
              marginwidth="0" />
          </div> -->
        </div>
      </div>

      <footer class="mdc-dialog__actions">
        <button
          on:click={() => close_map()}
          class="mdc-button mdc-button--unelevated">
          <span class="mdc-button__ripple" />
          {t9n(TS.LOGIN_FORM_CLOSE)}
        </button>
      </footer>
    </div>
  </div>

  <div class="mdc-dialog__scrim" />
</div>

<style>
  .mdc-data-table__cell {
    color: #616161;
    /*background-color: #fafafa;*/
  }

  .pre-wrap {
    white-space: pre-wrap !important;
  }

  /*tr.mdc-data-table__row:nth-child(1) > td:nth-child(2) {*/
  /*    white-space:pre*/
  /*}*/

  .cell-right {
    max-width: 200px;
    word-wrap: break-word;
    white-space: normal;
  }

  .mdc-data-table {
    width: 100%;
    border: 0;
    border-radius: 0;
    overflow-x: auto;
    /*border-style: 0;*/
  }

  .mdc-data-table__row {
    /*border-top-width: 1px;*/
    border-top-style: dashed;
  }

  th {
    font-weight: 800;
    text-align: left;
    max-width: 300px;
    min-width: 150px;
    /*word-wrap: break-word;*/
    /*white-space: normal;*/
  }

  td {
    width: 100%;
    font-weight: 500;
  }

  .showed_location {
    font-size: 12pt;
    margin-top: -5px;
  }

  .mapouter {
    position: relative;
    text-align: right;
    height: 500px;
    width: 750px;
  }

  .gmap_canvas {
    overflow: hidden;
    background: none !important;
    height: 500px;
    width: 750px;
  }

  .mdc-dialog .mdc-dialog__surface {
    max-width: 800px;
    width: 800px;
  }

  .btn-showonmap {
      align-self: center;
    /*position: relative;*/
    /*float: right;*/
    /*top: -10px;*/
  }

  .location-text {
    /*display: inline;*/
    /*position: relative;*/
    /*top: 20px;*/
  }

  .mdc-data-table__cell:before {
    content: attr(data-heading);
    display: inline-block;
  }

  .merge-cell {
    display: block;
    height: 100%;
    text-align: center;
    max-width: 334px;
  }

  .chat-map-expander {
    display: inline-grid !important;
  }

  .chat-p-margin-fixer {
      margin-bottom: 2px;
      margin-top: 2px;
     /* margin-top: -18px; */
  }

  .chat-map-height {
      height: 26px;
      margin-bottom: 4px;
  }

  /* Mobile / Tablet Mode
    *******************************************************/
  @media (min-width: 0) and (max-width: 1000px) {
    .mdc-dialog .mdc-dialog__surface {
      max-width: 100vw;
      width: 100%;
    }

    .btn-showonmap {
      position: relative;
      left: 1px;
      /*width: 10%;*/
      overflow: hidden;
      top: 13px;
      margin-bottom: 20px;
      height: 25px;
    }

    .location-text {
      top: 10px;
    }

    .mdc-dialog__container {
      height: 90%;
    }
  }
</style>
